export const toIpRange = (ipAddress: string, cidrPrefix: number): string =>
  `${ipAddress}/${cidrPrefix}`;
